import {OrderPallet, OrderParcel, OrderPlace} from '~/types/types';
import {useOrderStore} from '~/stores/order';
import {deepCopyObject} from '~/common/functions';

const useOrderCargo = (type: 'places'|'pallets'|'parcels') => {
  const orderStore = useOrderStore()

  const itemKey = ref(0)

  const defaultPlaceItem = computed(() => {
    switch (type) {
      case 'places':
        return {
          length: 0.2,
          width: 0.2,
          height: 0.2,
          weight: 0.9,
          count: 1,
          key: 0,
          wrapping: []
        } as OrderPlace
      case 'pallets':
        return {
          type: 'american',
          length: 1.2,
          width: 1.2,
          height: 0.2,
          weight: 0.9,
          count: 1,
          key: 0,
          wrapping: []
        } as OrderPallet
      case 'parcels':
        return {
        type: 0,
        weight: 0.9,
        count: 1,
        key: 0
      } as OrderParcel
    }
  }) 
  
  const storeItems = computed(() => {
    return orderStore.orderForm.cargo[type].items
  })

  const items = computed((): (OrderPlace|OrderPallet|OrderParcel)[] => {
    return storeItems.value.map((item, index) => {
      return {
        ...item,
        label: item.label || `Груз ${index + 1}`,
        key: item.key || index
      }
    })
  })

  const isOnlyOne = computed(() => {
    return items.value.length === 1
  })

  function getItem(index: number) {
    return storeItems.value[index]
  }

  function getItemParam(param: string, index: number) {
    return storeItems.value[index][param]
  }

  function setItemParam(param: string, index: number, value: string) {
    storeItems.value[index][param] = Number(value)
  }

  function onChangeItemParam(index: number, { param, value }: { param: string, value: string | number }) {
    if (storeItems.value[index]) {
      storeItems.value[index][param] = Number(value)
    }
    orderStore.getOrderPriceAction()
  }

  function addCard() {
    itemKey.value += 1
    storeItems.value.push({ ...defaultPlaceItem.value, key: itemKey.value, label: `Груз ${itemKey.value}` } as any)
    orderStore.getOrderPriceAction()
  }

  function removeCard(index: number) {
    if (items.value.length > 1) {
      storeItems.value.splice(index, 1)
      orderStore.getOrderPriceAction()
    }
  }

  function copyCard(index: number) {
    itemKey.value += 1
    storeItems.value.push(deepCopyObject(storeItems.value[index]) as any)
    const lastIndex = storeItems.value.length - 1
    if (storeItems.value[lastIndex].label?.startsWith(`Груз `)) {
      storeItems.value[lastIndex].label = `Груз ${itemKey.value}`
    }
    orderStore.getOrderPriceAction()
  }

  onMounted(() => {
    itemKey.value = items.value.length
  })

  return {
    items, isOnlyOne,
    getItem,
    getItemParam,
    setItemParam,
    onChangeItemParam,
    addCard,
    removeCard,
    copyCard
  }
}

export default useOrderCargo